// frontend/src/data/exampleScript.js
// Static example script shown in the ArtifactPanel "Example" modal.
// Same pair shape as session.script: { pairId, me, them, me_thought, them_thought }.

export const EXAMPLE_SCRIPT1 = [
  {
    pairId: 'example-0',
    me:           { source: 'user', content: "Congrats on getting the new product in the market" },
    them:         { source: 'user', content: "Thanks it was quite a challenge getting it out there" },
    me_thought:   { source: 'user', content: "...too bad it's not selling" },
    them_thought: { source: 'user', content: "I'm sure it was" },
  },
  {
    pairId: 'example-1',
    me:           { source: 'user', content: "Yeah these AI tools don't give you as much productivity boost as they'd like you to believe" },
    them:         { source: 'user', content: "Boy isn't that the truth we had a lot of quality issues" },
    me_thought:   { source: 'user', content: "There that's good" },
    them_thought: { source: 'user', content: "And that's honest" },
  },
  {
    pairId: 'example-2',
    me:           { source: 'user', content: "We're seeing the same thing with a lot of our customers. It seems that the AI isn't very good at creating code from average specs" },
    them:         { source: 'user', content: "Well, I think it's the developers. they're just not on top of things as they ought to be" },
    me_thought:   { source: 'user', content: "Here we go: the hard truth" },
    them_thought: { source: 'user', content: "He really doesn't get it" },
  },
  {
    pairId: 'example-3',
    me:           { source: 'user', content: "Do you suppose the issue could be with the specifications themselves?" },
    them:         { source: 'user', content: "No. I reviewed those personally myself and they're all well-written." },
    me_thought:   { source: 'user', content: "I need to be explicit" },
    them_thought: { source: 'user', content: "He's in denial" },
  },
  {
    pairId: 'example-4',
    me:           { source: 'user', content: "For people maybe but AI uses different kinds of specs" },
    them:         { source: 'user', content: "So, what are you saying, exactly?" },
    me_thought:   { source: 'user', content: "He just doesn't get it" },
    them_thought: { source: 'user', content: "ooops...he's offended" },
  },
  {
    pairId: 'example-5',
    me:           { source: 'user', content: "Well we've got a tool that will rewrite specs so that AI can read it" },
    them:         { source: 'user', content: "Sorry not interested thanks for dropping by though" },
    me_thought:   { source: 'user', content: "...maybe if he knew about our new product" },
    them_thought: { source: 'user', content: "Failed." },
  },
];


export const EXAMPLE_SCRIPT = [
  {
    pairId: 'example-0',
    me:           { source: 'user', content: "Hi George. How are things going?" },
    them:         { source: 'user', content: "Pretty well, but very busy." },
    me_thought:   { source: 'user', content: "George has a lot of smart people in his department, but he micromanages them. Let’s ease into this." },
    them_thought: { source: 'user', content: "He works hard. Be sure to acknowledge that." },
  },
  {
    pairId: 'example-1',
    me:           { source: 'user', content: "I appreciate how much work you’re doing for us." },
    them:         { source: 'user', content: "Thanks. But it’s OK. I like to be busy." },
    me_thought:   { source: 'user', content: "Maybe he’s too busy?" },
    them_thought: { source: 'user', content: "Maybe that’s part of the problem?" },
  },
  {
    pairId: 'example-2',
    me:           { source: 'user', content: "How do you think your department perceives you?" },
    them:         { source: 'user', content: "What do you mean?" },
    me_thought:   { source: 'user', content: "Is he open to feedback? Maybe if I ask some questions, he’ll get there on his own. Don’t want to upset him." },
    them_thought: { source: 'user', content: "Defensive. Why can’t he see it?" },
  },
  {
    pairId: 'example-3',
    me:           { source: 'user', content: "Well, how do you think they see you?" },
    them:         { source: 'user', content: "I like to think they see me as knowledgeable and that I put the best interests of XYZ corp first." },
    me_thought:   { source: 'user', content: "Try again!" },
    them_thought: { source: 'user', content: "Oh boy, he’s in denial. You need to empower your people more! Where to go from here?" },
  },
];
